import Main from '../../views/main'
import {ParentView} from '@/ladmin'

export default [
  {
    path: '/charging',
    name: 'charging',
    component: Main,
    meta: {
      disabled: true,
      label: '停车计费'
    },
    children: [
      {
        name: 'testRule',
        path: 'testRule',
        component: () => import(/* webpackChunkName: "reservation" */ '@/views/Charging/testRule'),
        meta: {
          label: '计费模拟测试',
        },
        children: [
        ]
      },
      {
        name: 'ChargingHistory',
        path: 'ChargingHistory',
        component: () => import(/* webpackChunkName: "reservation" */ '@/views/Charging/chargingHistoryList'),
        meta: {
          label: '计费结果查询',
        },
        children: [
        ]
      },
      {
        name: 'ruleConfigList',
        path: 'ruleConfigList',
        component: () => import(/* webpackChunkName: "reservation" */ '@/views/Charging/RuleConfig/ruleConfigList'),
        meta: {
          label: '计费规则配置',
        },
        children: [
        ]
      },
      {
        name: 'ruleConfigListParent',
        path: 'ruleConfigListParent',
        component: ParentView,
        meta: {
          label: '计费规则配置'
        },
        redirect: {name: 'ruleConfigList'},
        children: [
          {
            name: 'newRuleConfig',
            path: 'newRuleConfig',
            component: () => import(/* webpackChunkName: "reservation" */ '@/views/Charging/RuleConfig/ruleConfig'),
            meta: {
              label: '新增计费规则配置'
            }
          },
          {
            name: 'ruleConfig',
            path: 'ruleConfig',
            component: () => import(/* webpackChunkName: "reservation" */ '@/views/Charging/RuleConfig/ruleConfigBox'),
            meta: {
              label: '计费规则配置详情'
            }
          }
        ]
      },
      {
        name: 'ruleTemplateList',
        path: 'ruleTemplateList',
        component: () => import(/* webpackChunkName: "reservation" */ '@/views/Charging/RuleTemplate/ruleTemplateList'),
        meta: {
          label: '计费规则模板',
        },
        children: [
        ]
      },
      {
        name: 'ruleTemplateListParent',
        path: 'ruleTemplateListParent',
        component: ParentView,
        redirect: {name: 'ruleTemplateList'},
        meta: {
          label: '计费规则模板'
        },
        children: [
          {
            name: 'newRuleTemplate',
            path: 'newRuleTemplate',
            component: () => import(/* webpackChunkName: "reservation" */ '@/views/Charging/RuleTemplate/ruleTemplate'),
            meta: {
              label: '新增规则模板'
            }
          },
          {
            name: 'ruleTemplate',
            path: 'ruleTemplate',
            component: () => import(/* webpackChunkName: "reservation" */ '@/views/Charging/RuleTemplate/ruleTemplateBox'),
            meta: {
              label: '模板详情'
            }
          }
        ]
      },
      {
        name: 'ruleGroup',
        path: 'ruleGroupList',
        component: () => import(/* webpackChunkName: "reservation" */ '@/views/Charging/RuleGroup/ruleGroupList'),
        meta: {
          label: '计费规则分类',
        },
        children: [
        ]
      },
      {
        name: 'ruleGroupParent',
        path: 'ruleGroupParent',
        component: ParentView,
        redirect: {name: 'ruleGroup'},
        meta: {
          label: '计费规则分类'
        },
        children: [
          {
            name: 'ruleGroupForm',
            path: 'newRuleGroup',
            component: () => import(/* webpackChunkName: "reservation" */ '@/views/Charging/RuleGroup/ruleGroupForm'),
            meta: {
              label: '新增计费规则分类',
            },
          }
        ]
      }
    ]
  }
]
